import React from 'react';
import { RangeWrapper, RangeStyled, RangeOutput } from './Range.styled';

const Range = ({
  name,
  initialLabel = '',
  finalLabel = '',
  modifiers,
  onChange,
  ...props }, ref) => {
  const rangeRef = React.useRef(ref);
  const outputRef = React.useRef(null);

  const setRangeOutput = React.useCallback(() => {
    const { value, min, max } = rangeRef.current;
    /* calculate the range output position */
    const newValue = Number(((value - min) * 100) / (max - min));
    let outputPosition = 10 - newValue * 0.2;
    // verify where the thumb move to then add(left) or subs(right) two px
    outputPosition += outputPosition < 0 ? -2 : 2;

    outputRef.current.innerHTML = value;
    outputRef.current.style.left = `calc(${newValue}% + (${outputPosition}px))`;
  }, [rangeRef.current, outputRef.current]);

  const handleChange = React.useCallback(
    (event) => {
      setRangeOutput();
      onChange(event);
    },
    [setRangeOutput],
  );

  React.useImperativeHandle(ref, () => ({
    setValue(value) {
      rangeRef.current.value = value;

      setRangeOutput();
    },
  }));

  React.useEffect(() => {
    setRangeOutput();
  }, [setRangeOutput]);

  return (
    <RangeWrapper>
      <RangeStyled
        data-testid="range-input"
        innerRef={rangeRef}
        type="range"
        name={name}
        initiallabel={initialLabel}
        finallabel={finalLabel}
        modifiers={modifiers}
        onChange={(event) => handleChange(event)}
        {...props}
      />
      <RangeOutput ref={outputRef} htmlFor={name} />
    </RangeWrapper>
  );
};

export default React.forwardRef(Range);
